const defaultDuration = 8000

const NOTIFICATION_ADDED = 'NOTIFICATION_ADDED'
const NOTIFICATION_DISMISSED = 'NOTIFICATION_DISMISSED'
const NOTIFICATION_PERMISSION_GRANTED = 'NOTIFICATION_PERMISSION_GRANTED'
const NOTIFICATION_PERMISSION_DENIED = 'NOTIFICATION_PERMISSION_DENIED'

export default {
    namespaced: true,
    state: {
        queue: [],
        permission: !("Notification" in window) ? null : Notification.permission
    },
    getters: {
        // All notifications, we are returning only the raw notification objects
        queue: state => state.queue.map(n => n.raw),
        permission: state => state.permission
    },
    actions: {
        push({commit}, notification) {
            let duration = notification.duration || defaultDuration

            var timeOut = setTimeout(function () {
                commit(NOTIFICATION_DISMISSED, notification)
            }, duration)

            commit(NOTIFICATION_ADDED, {
                raw: notification,
                timeOut: timeOut
            })
        },
        dismiss(context, notification) {
            context.commit(NOTIFICATION_DISMISSED, notification)
        },
        permissionGranted({commit}) {
            commit(NOTIFICATION_PERMISSION_GRANTED)
        },
        permissionDenied({commit}) {
            commit(NOTIFICATION_PERMISSION_DENIED)
        }
    },
    mutations: {
        [NOTIFICATION_ADDED](state, notification) {
            state.queue.push(notification)
        },
        // remember, current state and payload
        [NOTIFICATION_DISMISSED](state, rawNotification) {
            let i = state.queue.map(n => n.raw).indexOf(rawNotification)
            if (i === -1) {
                return
            }

            clearTimeout(state.queue[i].timeOut)
            state.queue.splice(i, 1)
        },
        [NOTIFICATION_PERMISSION_GRANTED](state) {
            state.permission = 'granted'
        },
        [NOTIFICATION_PERMISSION_DENIED](state) {
            state.permission = 'denied'
        }
    }
}
